import { z, ZodType } from 'zod'

// Supports nested message clusters
export interface MessageCluster {
  [key: string]: string | MessageCluster
}

export const MessageClusterSchema: ZodType<MessageCluster> = z.lazy(() =>
  z.record(z.union([z.string(), MessageClusterSchema]))
)

export const MessageClusterRecordSchema = z.record(z.string(), MessageClusterSchema)

export type MessageClusterRecord = z.infer<typeof MessageClusterRecordSchema>
